<template>
  <div>
    <core-grid ref="grid" :onRead="onRead" :schema="schema"> </core-grid>
    <EmailTemplateAddEdit ref="editar" @close="response"></EmailTemplateAddEdit>
    <EmailTemplateDetails ref="templateDetails" @close="response"></EmailTemplateDetails>
    <EmailTemplateHtmlBody ref="templateHtmlBody" @close="response"></EmailTemplateHtmlBody>
  </div>
</template>

<script>
export default {
  components: {
    EmailTemplateAddEdit: () => import('./EmailTemplateAddEdit'),
    EmailTemplateDetails: () => import('./EmailTemplateDetails'),
    EmailTemplateHtmlBody: () => import('./EmailTemplateHtmlBody')
  },
  data () {
    return {
      schema: [
        { value: 'description', text: 'Descrição' },
        { value: 'productOrigin', text: 'Produto Origem' },
        { value: 'smtp.host', text: 'Host' },
        {
          format: 'optionButton',
          icon: 'fas fa-cogs',
          items: [
            {
              title: 'Detalhes',
              action: this.openEmailTemplateDetails
            },
            {
              title: 'Html Body',
              action: this.openEmailTemplateHtmlBody
            }
          ]
        }
      ]
    }
  },
  methods: {
    onRead: function (options, search) {
      const dto = { parameters: [{ name: 'search', value: search }] }
      this.$api.EmailTemplate.Get(`GetAll?${dto}`).then(function (response) {
        options.success(response)
      })
    },
    openModal (sender) {
      const th = this
      th.show = true
      if (sender) {
        th.model.id = sender.id
        th.model = Object.assign({}, { name: sender.id })
      }
    },
    openEmailTemplateDetails (e, curr) {
      e.preventDefault()
      const th = this
      if (curr) {
        th.$refs.templateDetails.openModal(curr)
      }
    },
    openEmailTemplateHtmlBody (e, curr) {
      e.preventDefault()
      const th = this
      if (curr) {
        th.$refs.templateHtmlBody.openModal(curr)
      }
    },
    refresh () {
      this.$refs.grid.refresh()
    },
    response (data) {
      if (data) {
        this.refresh()
      }
    },
    excluir (current) {
      const th = this
      if (current) {
        th.$api.EmailTemplate.Delete(current.id).then(function (data) {
          if (th.$api.UI.PostAction(data, `${current.id} removido com sucesso.`)) {
            th.refresh()
          }
        })
      }
    }
  }
}
</script>
